import { createSlice } from '@reduxjs/toolkit';
import { SESSION_STORAGE_KEY } from '../../constants/appConstants';

export const AUTH_MODE = {
  // User access by Azure
  AZURE: 'AZURE',
  // User access by custom backend api
  API: 'API',
  //User access by VC AUTH Login
  VCAUTH: 'VCAUTH',
};

/** @type {Session} */
let initialState = {
  userName: null,
  name: null,
  authMode: null,
  // Token for api call -> Provided from azure or custom backend api
  token: null,
  roles:null
};

const sessionData = sessionStorage.getItem(SESSION_STORAGE_KEY);

if (sessionData) {
  initialState = JSON.parse(sessionData);
}

export const sessionSlice = createSlice({
  name: 'session',
  initialState: {
    userName: null,
    name: null,
    authMode: null,
    token: null,
    roles:null,
    expires_in:null,
    issued_at:null,
    selectedRole: null as string | null,
  },
  reducers: {
    login: (state, action) => {
      const { userName, name, authMode, token, roles } = action.payload;
      state.userName = userName;
      state.name = name;
      state.authMode = authMode;
      state.token = token;
      state.roles = roles;
      state.expires_in = action.payload.expires_in;
      state.issued_at = action.payload.issued_at;
      sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(state));
    },
    logout: (state) => {
      state.userName = null;
      state.name = null;
      state.authMode = null;
      state.token = null;
      state.roles = null;
      state.expires_in = null;
      state.issued_at = null;
      state.selectedRole = null;
      sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(state));
      sessionStorage.clear();
    },
    setSelectedRole: (state, action) => {
      state.selectedRole = action.payload;
    },
  },
});

export const { login, logout, setSelectedRole } = sessionSlice.actions;

export const selectSession = (store:any) => store.session;


export default sessionSlice.reducer;